import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'ActivateOfferPage';

/**
 * Errors related to the Activate Offer page
 */
export const Errors = createErrors<Page, Component>('ActivateOffer')({
    ActivateOfferPage: {
        ActivateEmailOffer: {
            severity: 'MEDIUM',
            message: 'Failed to activate email offer',
        },
    },
});
